// THE EXPORT'S ELEVATION HALF, decided here so it can be tested without
// driving a PDF export.
//
// The multi-page plan export resolved no page's elevation extras, so a
// printed section of a page with the switches on showed its TAGGED levels
// while the model drew more. The live page was complete and the paper was
// not. Fixed by asking the server for every page at once (the cost is the
// boxes LOAD, not the per-page work) and passing each page's selection id
// into the three calls that build its section.

// WHICH PAGES ARE WORTH ASKING ABOUT. A page that did not switch either
// box on must not be in the request: it would cost a band and a selection
// document for an answer nobody asked for.
export function elevationAsk(targets) {
  return (targets || [])
    .filter((t) => t && t.cut && (t.cut.atElevation || t.cut.untaggedAtElevation))
    .map((t) => ({
      pageId: String(t.pageId || ""),
      levels: t.levels || [],
      atElevation: !!t.cut.atElevation,
      untaggedAtElevation: !!t.cut.untaggedAtElevation,
      // The same defaults the panel shows, so a page saved before the two
      // reaches existed searches the band it would have searched on screen
      // rather than a zero-width one.
      elevBelow: t.cut.elevBelow == null ? 2 : t.cut.elevBelow,
      elevAbove: t.cut.elevAbove == null ? 2 : t.cut.elevAbove,
    }));
}

// WHAT THE WHOLE EXPORT HAS TO ADMIT. A page whose extras could not be
// resolved is printed with its tagged levels, and that has to be SAID -
// a section that quietly shows less than the model is the bug, and the
// fallback is only acceptable when it is named.
export function taggedOnlyFrom(targets, rows) {
  const byId = new Map((rows || []).map((r) => [String(r.pageId), r]));
  const out = [];
  for (const t of targets || []) {
    const r = byId.get(String(t.pageId || ""));
    if (r && r.note) out.push({ title: t.title, note: r.note });
  }
  return out;
}

// THE ID A PAGE'S THREE CALLS CARRY, or "" for none. A row with a note and
// no id is a page that asked and could not be served - it still gets "",
// because the alternative is passing a broken id and having the server
// resolve it to an EMPTY selection, which would narrow the section to
// nothing instead of to its tagged levels.
export function cutUidsFor(rows, pageId) {
  const r = (rows || []).find((x) => String(x.pageId) === String(pageId));
  return r && r.selectionId ? String(r.selectionId) : "";
}

// Every page that failed, when the whole batch call failed: one reason,
// repeated, rather than silence on each.
export function askFailedRows(ask, message) {
  return (ask || []).map((a) => ({
    pageId: a.pageId,
    selectionId: "",
    added: 0,
    range: null,
    note: `The elevations could not be read (${message || "the request failed"}), so this page shows the elements tagged to its levels only.`,
  }));
}
